import { Project } from '../../models/project';

import { ApiResponse, httpService } from '../httpService';

export interface GetProjectsParams {
  skip?: number;
  take?: number;
  filter?: string;
  includeDeleted?: boolean;
  managerId?: string;
  ongoingProjectsOnly?: boolean;
  clientId?: string;
  towerId?: string;
  projectManagerId?: string;
  budgetOwnerId?: string;
  salesPersonId?: string;
}

export interface GetClientProjectsParams {
  skip?: number;
  take?: number;
  filter?: string;
  includeDeleted?: boolean;
  managerId?: string;
}

const projectsApiUrl = '/api/Projects';

export const getProjects = async (
  params: GetProjectsParams = {}
): Promise<ApiResponse<Project>> => {
  const response = await httpService.get<ApiResponse<Project>>(projectsApiUrl, {
    params,
  });

  return response.data;
};

export const getClientProject = async (
  idClient: string,
  params: GetClientProjectsParams = {}
): Promise<ApiResponse<Project>> => {
  const response = await httpService.get<ApiResponse<Project>>(
    `/api/Clients/${idClient}/Projects`,
    { params }
  );

  return response.data;
};

export const addNewProject = async (
  newProject: Partial<Project>
): Promise<void> => {
  await httpService.post(projectsApiUrl, newProject);
};

export const editProject = async (
  idProject: string,
  editProjectInfo: Partial<Project>
): Promise<void> => {
  await httpService.put(`${projectsApiUrl}/${idProject}`, editProjectInfo);
};

export const deleteProject = async (idProject: string): Promise<void> => {
  await httpService.delete(`${projectsApiUrl}/${idProject}`);
};

export const getProjectById = async (idProject: string): Promise<Project> => {
  const response = await httpService.get<Project>(
    `${projectsApiUrl}/${idProject}`
  );

  return response.data;
};
